<template>
  <div>
    <MultipleAreaBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :tables="pageData"
      :isFooter="isFooter"
      isFooterColor="false"
    >
      <template v-slot:[pageData[0].name]>
        <div class="pa-4 pl-7 refundDetailsStyle">
          <div class="pb-1 d-flex">
            <div style="width: 100px">
              {{ $t('refund.refund_target-order-number') + ':' }}
            </div>
            <div>{{ refundData.controlNo }}</div>
          </div>
          <div class="pb-1 d-flex">
            <div style="width: 100px">
              {{ $t('refund.refund_refund-warehousing-warehouse') + ':' }}
            </div>
            <div>{{ refundData.storage.label }}</div>
          </div>
          <div class="pb-1 d-flex">
            <div style="width: 100px">
              {{ $t('refund.refund_refund-date') + ':' }}
            </div>
            <div>{{ refundData.refundDate }}</div>
          </div>
        </div>
      </template>

      <template v-slot:[pageData[1].name]>
        <ProductTable
          :headers="recDetail.productListHeaders"
          :items="productData[0].sale.productMoves"
          item-key="product.productId"
          productKey="productMoveId"
          :isRefund="true"
        >
          <template v-slot:quantityAndStorageNo="{ item }">
            <div
              v-for="(rec, index) in productInputData[
                getProductInputDataIndex(item.productMoveId)
              ].rackInfoList"
              :key="index"
            >
              {{ getDispQuantityRackNo(rec) }}
            </div>
          </template>
          <template v-slot:refundPurchasePrice="{ item }">
            {{
              getDispRefundPurchasePrice(item.productMoveId) +
              getRefundPurchaseUnit(item.productMoveId)
            }}
          </template>
          <template v-slot:refundPurchaseAmount="{ item }">
            {{
              getDispRefundPurchaseAmount(item.productMoveId) +
              getRefundPurchaseUnit(item.productMoveId)
            }}
          </template>
          <template v-slot:refundPrice="{ item }">
            {{ getDispPrice(item.productMoveId) + getUnit(item) }}
          </template>
          <template v-slot:amount="{ item }">
            {{ getDispAmount(item.productMoveId) + getUnit(item) }}
          </template>
          <template v-slot:exportSubjectFlg="{ item }">
            {{ getDispExportSubject(item.productMoveId) }}
          </template>
        </ProductTable>
      </template>

      <template v-slot:[pageData[2].name]>
        <v-row class="mx-3 my-2">
          <v-col cols="6">
            <Remarks title="" text="" v-model="remarks" />
          </v-col>
        </v-row>
      </template>

      <template #footer>
        <TotalAmountRefund
          v-model="totalList.totalList"
          :productListData="totalList.product"
          :isRegister="false"
          :textColorFlag="true"
        />
        <NormalButton
          :text="$t('common.input_fix')"
          color="white"
          class="pr-5"
          textColor="thinText--text"
          height="50px"
          width="130px"
          @click="inputedValue.dialog = false"
        />
        <NormalButton
          :text="$t('common.input_save')"
          height="50px"
          width="130px"
          @click="register()"
        />
        <DialogAlertSuccess
          v-model="completeDialog"
          :text="$t('common.common_register-complete')"
        />
      </template>
    </MultipleAreaBase>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import MultipleAreaBase from '../MultipleAreaBase'
import DialogAlertSuccess from '@/components/layouts/Dialogs/DialogAlert/DialogAlertSuccess'

import headersHistory from '@/views/sales/History/headers'
import {
  ProductTable,
  Remarks,
  TotalAmountRefund,
  NormalButton
} from '@/components/items'
import { currencyUtil } from '@/util'

// import NormalButton from '@/components/items/Buttons/NormalButton'

export default {
  components: {
    MultipleAreaBase,
    ProductTable,
    Remarks,
    TotalAmountRefund,
    NormalButton,
    DialogAlertSuccess
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    totalList: {
      type: Object,
      require: false,
      default: () => ({})
    },
    productData: {
      require: false,
      default: () => []
    },
    productInputData: {
      require: false,
      default: () => []
    },
    refundData: {
      type: Object,
      require: false,
      default: () => ({})
    },

    isHistoryType: { default: false },
    isFooter: { default: false },
    isEdit: { default: false },
    isTotalAmount: { default: true }
  },
  data: () => ({
    completeDialog: false,
    pageType: {
      en: 'sale',
      ja: '注文'
    },
    pageData: [
      {
        title: 'refund.refund_refund-info',
        name: 'refundInfo'
      },
      {
        title: 'refund.refund_refund-details',
        name: 'refundDetail'
      },
      {
        title: 'sale.sale_note',
        name: 'spplierInfo'
      }
    ],

    recDetail: {
      productListHeaders: [
        {
          text: 'product.product_product-number',
          value: 'product.productNumber',
          sortable: false,
          width: '100px',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'center'
        },
        {
          text: 'common.product_product-name',
          value: 'productName',
          sortable: false,
          width: '200px',
          class: 'rgba(151, 198, 234, 0.1)'
        },
        {
          text: 'common.product_consumption-tax-rate',
          value: 'product.taxId',
          sortable: false,
          width: '89px',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'center',
          unit: '%'
        },
        {
          text: 'common.product_capacity',
          value: 'product.capacity',
          sortable: false,
          width: '89px',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'center'
        },
        {
          text: 'refund.refund_refund-quantity-rack',
          value: 'quantityAndStorageNo',
          sortable: false,
          width: '158px',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'center'
        },
        {
          text: 'refund.refund_refund-purchase-unit-price',
          value: 'refundPurchasePrice',
          sortable: false,
          width: '100px',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'end'
        },
        {
          text: 'refund.refund_refund-purchase-price',
          value: 'refundPurchaseAmount',
          sortable: false,
          width: '100px',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'end'
        },
        {
          text: 'refund.refund_refund-unit-price',
          value: 'refundPrice',
          sortable: false,
          width: '100px',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'end'
        },
        {
          text: 'refund.refund_refund-price',
          value: 'amount',
          sortable: false,
          width: '100px',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'end'
        },
        {
          text: 'sale.sale_exporter',
          value: 'exportSubjectFlg',
          sortable: false,
          width: '80px',
          class: 'rgba(151, 198, 234, 0.1)',
          align: 'center'
        }
      ]
    },

    remarks: ''
  }),
  methods: {
    ...mapActions('Refund', ['registerRefund']),
    ...mapActions('Common', ['setIsLoading']),
    getProductInputDataIndex(productMoveId) {
      return this.productInputData.findIndex(
        (ele) => ele.productMoveId === productMoveId
      )
    },
    getDispQuantityRackNo(rackInfo) {
      const rackNo = rackInfo.rackNumber
        ? rackInfo.rackNumber
        : this.$t('common.common_no-rack-number')
      return `${rackInfo.quantity}（${rackNo}）`
    },
    getRefundPurchaseUnit(productMoveId) {
      const target =
        this.productInputData[this.getProductInputDataIndex(productMoveId)]
      return currencyUtil.findCurrencyNameById(target.currency.value).unitName
    },
    getDispRefundPurchasePrice(productMoveId) {
      const target =
        this.productInputData[this.getProductInputDataIndex(productMoveId)]
      return target.price
    },
    getDispRefundPurchaseAmount(productMoveId) {
      const target =
        this.productInputData[this.getProductInputDataIndex(productMoveId)]
      const quantity = target.rackInfoList.reduce((res, cur) => {
        return (res += cur.quantity)
      }, 0)
      const amount = quantity * target.price
      return amount
    },
    getUnit(item) {
      return currencyUtil.findCurrencyNameById(item.currencyId).unitName
    },
    getDispAmount(productMoveId) {
      const target =
        this.productInputData[this.getProductInputDataIndex(productMoveId)]
      const quantity = target.rackInfoList.reduce((res, cur) => {
        return (res += cur.quantity)
      }, 0)
      const amount = quantity * target.refundPrice * -1
      return amount
    },
    getDispPrice(productMoveId) {
      const target =
        this.productInputData[this.getProductInputDataIndex(productMoveId)]
      return target.refundPrice * -1
    },
    getDispExportSubject(productMoveId) {
      const target =
        this.productInputData[this.getProductInputDataIndex(productMoveId)]
      return target.exportSubjectFlg
        ? this.$t('sale.sale_exporter-table-style-last-line')
        : ''
    },
    async register() {
      this.setIsLoading(true)
      // 消費税・調整金額の正負反転
      this.totalList.totalList.tax8.tax *= -1
      this.totalList.totalList.tax10.tax *= -1
      this.totalList.totalList.adjust *= -1
      const isSuccess = await this.registerRefund({
        refundData: this.refundData,
        productData: this.productInputData,
        totalList: this.totalList.totalList,
        remarks: this.remarks
      })
      if (isSuccess) {
        this.completeDialog = true
      }
      this.setIsLoading(false)
    }
    // cancel(id) {
    //   this.$emit('cancel', id)
    // },
    // edit(rec) {
    //   this.$emit('edit')
    // }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    completeDialog: function (newVal, oldVal) {
      if (!newVal && oldVal) {
        this.$router.push({
          name: 'sales.refund.history'
        })
        this.inputedValue.dialog = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
// .productTableCom {
//   ::v-deep .v-data-table th {
//     background-color: rgba(151, 198, 234, 0.1);
//     padding-left: 30px;
//   }
//   ::v-deep .v-data-table td {
//     padding-left: 30px;
//   }
// }
.normalNumberInput {
  width: 180px;
}
.stepComponent {
  width: 150px;
}
.btnStyle {
  width: 90px;
}
.d-flex {
  display: flex;
}
.refundDetailsStyle {
  font-size: 12px !important;
}
</style>
